import {createContext, FC, ReactNode, useContext} from 'react';
import {useTranslation} from 'react-i18next';
import {Locale} from 'types';
import getPreferredLanguage from 'utils/locale';
import 'i18n';

const LocaleContext = createContext<Locale>(getPreferredLanguage());

export const useLocale = (): Locale => {
    const context = useContext(LocaleContext);

    if (context === undefined) {
        throw new Error('useLocale must be used within a LocaleProvider');
    }

    return context;
};

const LocaleProvider: FC<{children: ReactNode}> = ({children}) => {
    const {i18n} = useTranslation();
    const language = (i18n.language || getPreferredLanguage()) as Locale;

    return (
        <LocaleContext.Provider value={language as Locale}>
            {children}
        </LocaleContext.Provider>
    );
};
export default LocaleProvider;
